import React from "react";
import PropTypes from "prop-types";
//import material-ui components
import withStyles from "@material-ui/core/styles/withStyles"
import IconButton from "@material-ui/core/IconButton";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
//import material icons
import Close from "@material-ui/icons/Close"
//import core components
import Button from "components/CustomButtons/Button.jsx";

import modalStyle from "assets/jss/material-kit-react/modalStyle.jsx";

class ConfirmDeleteDialog extends React.Component {
    render(){
        const { classes, onCancel, onSave, isOpened, bodyText, headerText, buttonText } = this.props;
        return (
            <Dialog
                classes={{
                    root: classes.center,
                    paper: classes.modal
                }}
                open={isOpened}
                onClose={() => onCancel()}
            >
                <DialogTitle
                    disableTypography
                    className={classes.modalHeader}
                >
                    <IconButton
                        className={classes.modalCloseButton}
                        key="close"
                        aria-label="Close"
                        color="inherit"
                        onClick={() => onCancel()}
                    >
                        <Close className={classes.modalClose} />
                    </IconButton>
                    <h4 className={classes.modalTitle} >{headerText ? headerText : "Вы уверены?"}</h4>
                </DialogTitle>
                <DialogContent className={classes.modalBody}>
                    <p>{ bodyText }</p>
                </DialogContent>
                <DialogActions className={classes.modalFooter} >
                    <Button color="danger"
                        onClick={() => onSave()}
                    >
                        {buttonText ? buttonText : "Удалить"}
                    </Button>
                    <Button color="primary" simple
                        onClick={() => onCancel()}
                    >
                        Отменить
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

ConfirmDeleteDialog.propTypes = {
    isOpened: PropTypes.bool,
    onCancel: PropTypes.func,
    onSave: PropTypes.func,
    bodyText: PropTypes.string,
    headerText: PropTypes.string,
    buttonText: PropTypes.string,
};

export default withStyles(modalStyle)(ConfirmDeleteDialog);


// WEBPACK FOOTER //
// ./src/components/Dialogs/ConfirmDeleteDialog.jsx